import {Button, Form, InputGroup, Table} from "react-bootstrap";
import {useFormContext} from "../../../components/forms/formElements";
import useAlert from "../../../components/CustomAlert";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons";
import { useDataProvider } from "../../../providers/offline_data_provider";

export default function DeviceSelect(props){

    const element = props.value;
    const {onChange} = useFormContext()
    const {devices} = useDataProvider();
    const {alert, showAlert, hideAlert} = useAlert();


    const handleAddDevice = (event)=>{
        const deviceId = event.target.value;

        const index = element.value.findIndex(d=>d.id === deviceId)

        if(index > -1)
            return;

        const device = devices.find(d=>d.id === deviceId);

        if(!device)
            return;

        element.value.push({...device})

        onChange(element);
    }

    const handleRemoveDevice = (deviceId)=>{
        const index = element.value.findIndex(d=>d.id === deviceId)

        if(index < 0)
            return;

        element.value.splice(index, 1)

        onChange(element);
    }

    return (
        <div>
            {alert()}
            <Table striped bordered >
                <thead>
                    <tr>
                        <th>L.p.</th>
                        <th>Urządzenie</th>
                        <th>Usuń</th>
                    </tr>
                </thead>
                <tbody>
                {
                    element.value?.map((device, lp)=>{

                        return <tr key={lp}>
                            <td>{lp+1}</td>
                            <td>{device.description} {device.symbol} numer seryjny: {device.sn}</td>
                            <td><Button variant={"outline-dark"} onClick={()=>{handleRemoveDevice(device.id)}}><FontAwesomeIcon icon={faTrash} /></Button> </td>
                        </tr>
                    })
                }
                </tbody>
            </Table>

            <InputGroup className="mb-3 w-50">
                <InputGroup.Text>Wybierz urządzenie</InputGroup.Text>
                <Form.Select value={""} onChange={handleAddDevice}>
                    <option></option>
                    {
                        devices && devices.map(device=>{
                            return <option key={device.id} value={device.id}>{device.description} {device.symbol} numer seryjny: {device.sn}</option>
                        })
                    }
                </Form.Select>
            </InputGroup>


        </div>
    )
}